import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(tienda)/[slug]/CategoryPageClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(tienda)/[slug]/ProductPageClient.tsx");
